import { Icon, IconButton, Image } from "components";
import { Layout } from "layouts";
import { sortBy } from "lodash";
import Error404 from "pages/Error404";
import { useMemo } from "react";
import { To, useLocation } from "react-router";
import { Link, useSearchParams } from "react-router-dom";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Magazine } from "types";

export default function BannerDetails() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const banner = location.state as Magazine.BannerItem | null;
  const album = useMemo(() => {
    return sortBy(banner?.album ?? [], (e) => e.displayOrder);
  }, [banner?.album]);
  // const bannerId = searchParams.get("bannerId");
  const imageId = searchParams.get("imageId");
  const index = useMemo(() => {
    const initIndex = album?.findIndex((e) => e.id === imageId);
    const index = initIndex !== -1 ? initIndex : 0;
    return index;
  }, [album, imageId]);
  const showArrows = (album?.length ?? 0) > 1;
  if (!banner || !album?.length) return <Error404 />;
  return (
    <section className="bg-black w-full min-h-[100svh]">
      <Layout>
        <Layout.Header
          className="bg-black"
          divProps={{
            className: "grid grid-cols-[1fr_auto_1fr] items-center gap-2",
          }}
        >
          <IconButton
            as={Link}
            to={-1 as To}
            type="button"
            className="text-white w-fit self-start"
          >
            <Icon name="ArrowLeft2" />
          </IconButton>
          <h6 className="text-center flex-1 text-base text-white font-semibold">
            Photo
          </h6>
        </Layout.Header>
        <Layout.Body className="flex flex-col h-[calc(100svh-4.25rem)] text-white px-0">
          <section className="flex-1 w-full flex flex-col relative">
            {showArrows && (
              <div className="absolute inset-0 w-full h-fit my-auto flex items-center justify-between z-10 pointer-events-none *:pointer-events-auto">
                <IconButton
                  type="button"
                  variant="text"
                  className="text-white opacity-50 swiper-button-prev prev-image disabled:opacity-0"
                >
                  <Icon name="ArrowCircleLeft" variant="Bold" />
                </IconButton>
                <span className="flex-1"></span>
                <IconButton
                  type="button"
                  variant="text"
                  className="text-white opacity-50 swiper-button-next next-image disabled:opacity-0"
                >
                  <Icon name="ArrowCircleRight" variant="Bold" />
                </IconButton>
              </div>
            )}
            <Swiper
              initialSlide={index}
              spaceBetween={4}
              slidesPerView={1}
              className="size-full"
              navigation={{
                prevEl: ".prev-image",
                nextEl: ".next-image",
              }}
              modules={[Navigation]}
            >
              {album.map((e) => (
                <SwiperSlide key={e.url} className="size-full">
                  <Image
                    src={e.url}
                    alt={e.mimeType}
                    className="size-full object-contain"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </section>
          <div className="pt-6 pb-16 px-5 space-y-2.5">
            <h3 className="text-base font-medium text-white empty:hidden">
              {banner.title}
            </h3>
            <p className="text-sm font-normal text-white empty:hidden">
              {banner.subTitle}
            </p>
          </div>
        </Layout.Body>
      </Layout>
    </section>
  );
}
